import {
  Checkbox,
  ContentsHeader,
  InformationBanner,
  Pagination,
  PrimaryButton,
  Table,
  TableBody,
  TableHeader,
  TableRow,
  Td,
  Th,
} from "@graffer-inc/console-design-kit";
import { SmartApplyTemplate } from "../../../template/smart-apply/default-template";
import { SmartApplyR } from "../route";
import { Redirect, useHistory, useLocation } from "react-router-dom";
import dayjs, {
  formatOnlyDate,
  unixSecToTimeString,
} from "../../../../utils/date-utils";
import { SmartApplyMenuList } from "../../../organisms/smart-apply/menu-list";
import { useApplicationRemovalTaskList } from "./hook";
import { ApplicationRemovalTaskStatusTag } from "../../../molecules/application-removal-task/application-removal-task-status-tag";
import { useAuthContextV2 } from "../../../../auth-state";
import {
  parseQueryOfLocation,
  rebuildQuery,
} from "../../../../utils/url-utils";
import { toast } from "react-toastify";

export const ApplicationRemovalTaskList: React.FC = () => {
  const history = useHistory();
  const { auth } = useAuthContextV2();
  const { page } = parseQueryOfLocation(useLocation()) as {
    page: string | undefined;
  };

  const {
    ApplicationRemovalTasks,
    resolveGroupName,
    enableGroupIDFilter,
    toggleGroupIDFilter,
    currentPage,
    setCurrentPage,
    totalPage,
  } = useApplicationRemovalTaskList(auth, Number(page));

  const movePage = (page: number) => {
    history.push(
      rebuildQuery({
        page: page.toString(),
      }),
    );
    setCurrentPage(page);
  };

  if (
    !auth.checkGroupPermissionWithoutTarget(["applications.removal_tasks_read"])
  ) {
    toast.error("このページを閲覧する権限がありません。");
    return <Redirect to={SmartApplyR.Applications.link({})} />;
  }

  return (
    <SmartApplyTemplate
      breadcrumbs={[{ to: "#", title: "申請削除タスク一覧" }]}
      menuList={<SmartApplyMenuList />}
      contentsHeader={
        <ContentsHeader
          title={"申請削除タスク一覧"}
          caption={[]}
          captionDirection="row"
          buttons={[
            [
              <PrimaryButton
                key={"remove-application"}
                text={"削除タスクを登録する"}
                onClick={() => {
                  history.push(
                    SmartApplyR.ApplicationRemovalTaskRegister.link({}),
                  );
                }}
              />,
            ],
          ]}
        />
      }
    >
      {!auth.hasRole("Admin") && (
        <>
          <Checkbox
            label={""}
            description={""}
            options={[
              {
                name: "所属するグループのタスクを表示する",
                value: "enableGroupIDFilter",
              },
            ]}
            values={enableGroupIDFilter ? ["enableGroupIDFilter"] : []}
            onChange={() => toggleGroupIDFilter()}
          />
        </>
      )}
      <Table wrapper={false} borderType="row">
        <TableHeader>
          <TableRow>
            <Th>ステータス</Th>
            <Th>管理グループ</Th>
            <Th>対象手続き</Th>
            <Th>削除予定日</Th>
            <Th>削除予定件数</Th>
          </TableRow>
        </TableHeader>
        <TableBody>
          {ApplicationRemovalTasks.length === 0 ? (
            <TableRow>
              <Td colSpan={5}>
                <InformationBanner message="申請削除タスクがまだ登録されていません。" />
              </Td>
            </TableRow>
          ) : (
            ApplicationRemovalTasks.map((task) => (
              <TableRow
                key={task.id}
                onClick={() => {
                  history.push(
                    SmartApplyR.ApplicationRemovalTaskDetail.link({
                      id: task.id,
                    }),
                  );
                }}
              >
                <Td>
                  <ApplicationRemovalTaskStatusTag status={task.status} />
                </Td>
                <Td>{resolveGroupName(task.groupId)}</Td>
                <Td>{`${task.procedureName}`}</Td>
                <Td>
                  {formatOnlyDate(
                    dayjs(unixSecToTimeString(task.scheduledRemoveUnixtime)),
                  )}
                </Td>
                <Td>{`${task.targetApplicationsCount}件`}</Td>
              </TableRow>
            ))
          )}
        </TableBody>
      </Table>
      {ApplicationRemovalTasks.length !== 0 && (
        <Pagination
          onPageClick={movePage}
          currentPage={currentPage}
          lastPage={totalPage}
        />
      )}
    </SmartApplyTemplate>
  );
};
